<template lang="pug">
  .component-packet-buttons
    packet-modal(:packet="item", :title="title", @itemUpdated="$emit('itemUpdated')")
      .dropdown-buttons
        button.button Edit
</template>

<script>
import ActionButton from "../ActionButton";
import PacketModal from "./reveal/PacketModal";

export default {
  name: "PacketButtons",
  components: {PacketModal, ActionButton},
  data() {
    return {
      title : 'Update packet',
    }
  },
  created() {
  },
  methods: {},
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketButtons.vue?3ccf9d82